import { useEffect, useState } from 'react'

type Theme = 'light' | 'dark'

function systemTheme(): Theme {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

// Single-button day/night toggle: persists an explicit choice to localStorage,
// otherwise follows the OS preference live.
export function useThemeToggle() {
  const [theme, setTheme] = useState<Theme>('light')
  const [hasExplicitChoice, setHasExplicitChoice] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem('os-theme') as Theme | null
    if (stored === 'light' || stored === 'dark') {
      setTheme(stored)
      setHasExplicitChoice(true)
    } else {
      setTheme(systemTheme())
    }

    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => {
      if (!localStorage.getItem('os-theme')) setTheme(systemTheme())
    }
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  const toggle = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    setHasExplicitChoice(true)
    localStorage.setItem('os-theme', next)
  }

  return { theme, toggle, hasExplicitChoice }
}
